import React, { Suspense } from 'react';
import { preloadImageForSuspense } from './utils/preloadImageForSuspense';
const Loader = ({ className = '', uniqClassName }) => (React.createElement("span", { className: uniqClassName ?? `pos:a z:4 t:0 l:0 r:0 b:0 lh:0 ${className}`, style: { animation: 'unset' } },
    React.createElement("span", { className: "pos:a t:50p l:50p trf:t:-50p" },
        React.createElement("i", { className: "d:block icon--loader fz:36" }))));
const Image = (props) => {
    props.src !== undefined &&
        preloadImageForSuspense({
            src: props.src,
            srcSet: props.srcSet,
            sizes: props.sizes
        });
    return (React.createElement("img", { ...props }));
};
export const SuspenseImage = ({ loaderClassName, ...imgProps }) => {
    return (React.createElement(Suspense, { fallback: React.createElement(Loader, { className: imgProps.className, uniqClassName: loaderClassName }) },
        React.createElement(Image, { ...imgProps })));
};
